<template>
  <div class="row" v-if="canAccess">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <div class="card-header">
              <h4 class="card-title">Sales Dashboard</h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-2">
              <div><label>Game</label></div>
              <a-select
                v-model:value="selects.game"
                style="width: 100%"
                placeholder="เลือกเกม"
                :options="selects.games"
              />
            </div>
            <div class="col-md-2">
              <div><label>Period</label></div>
              <a-select
                v-model:value="selects.period"
                style="width: 100%"
                placeholder="เลือกช่วงเวลา"
                :options="selects.periods"
              />
            </div>
            <div class="col-md-2">
              <div><label>Payment Method</label></div>
              <a-select
                v-model:value="selects.paymentMethod"
                style="width: 100%"
                placeholder="เลือกช่องทางการชำระเงิน"
                :options="selects.paymentMethods"
              />
            </div>
            <div class="col-md-2">
              <div><label style="color: transparent">ดึงข้อมูล</label></div>
              <a-button
                type="primary"
                :loading="dataReceiving"
                @click="getDashboardData()"
              >
                ดึงข้อมูล
              </a-button>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-8">
              <vue3-chart-js
                :id="salePeriodChart.id"
                ref="chartRef"
                :type="salePeriodChart.type"
                :data="salePeriodChart.data"
                @before-render="beforeRenderLogic"
                :style="hasSaleData ? '' : 'display: none;'"
              ></vue3-chart-js>
              <a-spin :spinning="dataReceiving">
                <a-empty
                  style="padding: 100px"
                  description="ไม่พบข้อมูล"
                  v-if="!hasSaleData"
                />
              </a-spin>
            </div>
            <div class="col-md-4 text-center">
              <div class="row">
                <div class="col-md-12">
                  <a-card style="font-size: 14px !important">
                    <h5 class="title">Sales Revenue</h5>
                    <p class="category" style="font-size: 14px">
                      {{ salesRevenue.period }}
                    </p>
                    <h1 class="card-title">{{ salesRevenue.total }}</h1>
                    <p>บาท</p>
                  </a-card>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-md-12">
                  <a-card style="font-size: 14px !important">
                    <h5 class="title">Top 3 Package Sales</h5>
                    <el-table :data="tableData">
                      <el-table-column
                        label="Package"
                        align="center"
                        property="packageName"
                      ></el-table-column>
                      <el-table-column
                        label="Qty"
                        align="center"
                        property="totalSale"
                      ></el-table-column>
                    </el-table>
                  </a-card>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <div class="row">
              <div class="col-md-4">
                <vue3-chart-js
                  :id="saleTypeChart.id"
                  ref="chartSaleTypeRef"
                  :type="saleTypeChart.type"
                  :data="saleTypeChart.data"
                  @before-render="beforeRenderLogic"
                ></vue3-chart-js>
              </div>
              <div class="col-md-8">
                <vue3-chart-js
                  :id="noOfSaleChart.id"
                  ref="chartNoRef"
                  :type="noOfSaleChart.type"
                  :data="noOfSaleChart.data"
                  @before-render="beforeRenderLogic"
                ></vue3-chart-js>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <vue3-chart-js
              :id="dailyChart.id"
              ref="chartDailyRef"
              :type="dailyChart.type"
              :data="dailyChart.data"
              @before-render="beforeRenderLogic"
            ></vue3-chart-js>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" v-if="canAccess === false">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <a-result
            status="403"
            title="403"
            sub-title="ขออภัย คุณไม่ได้รับอนุญาตให้เข้าถึงหน้านี้"
          >
            <template #extra>
              <a-button type="primary" @click="goToHome">กลับหน้าหลัก</a-button>
            </template>
          </a-result>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as configuration from "../../middleware/configuration";
import * as gameservice from "../../services/game";
import * as paymentservice from "../../services/payment";
import * as dashboardservice from "../../services/dashboard";

import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
import colorLib from "@kurkle/color";
import moment from "moment";
import { ElTable, ElTableColumn } from "element-plus";
import { message } from "ant-design-vue";

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const CHART_COLORS = {
  red: "rgb(255, 99, 132)",
  orange: "rgb(255, 159, 64)",
  yellow: "rgb(255, 205, 86)",
  green: "rgb(75, 192, 192)",
  blue: "rgb(54, 162, 235)",
  purple: "rgb(153, 102, 255)",
  grey: "rgb(201, 203, 207)",
};

const COLORS = [
  "#4dc9f6",
  "#f67019",
  "#f53794",
  "#537bc4",
  "#acc236",
  "#166a8f",
  "#00a950",
  "#58595b",
  "#8549ba",
];
const key = "updatable";

export default {
  components: {
    Vue3ChartJs,
    [ElTable.name]: ElTable,
    [ElTableColumn.name]: ElTableColumn,
  },
  methods: {
    async getGames() {
      try {
        let res = await gameservice.get("games");
        res.data.map((m) => {
          this.selects.games.push({ value: m.id, label: m.name });
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.selects.gameLoaded = true;
      }
    },
    async getPaymentMethods() {
      try {
        let res = await paymentservice.getPaymentMethods();
        res.data.map((m) => {
          this.selects.paymentMethods.push({ value: m.code, label: m.name });
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.selects.paymentLoaded = true;
      }
    },
    getRandomColor() {
      var letters = "0123456789ABCDEF".split("");
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    async getDashboardData() {
      let dataReq = {
        game: this.selects.game,
        period: this.selects.period,
        paymentMethod: this.selects.paymentMethod,
      };

      if (
        dataReq.game === null ||
        dataReq.period === null ||
        dataReq.paymentMethod === null
      ) {
        message.warning({ content: "กรุณาเลือก Criteria!", key, duration: 2 });
        return;
      }
      this.dataReceiving = true;
      await this.getSale(dataReq);
      await this.getNoOfSale(dataReq);
      await this.getSaleRevenue(dataReq);
      await this.getTop3(dataReq);
      await this.getDailyRevenue(dataReq);
      await this.getSaleType(dataReq);
    },
    async getSale(dataReq) {
      try {
        let res = await dashboardservice.get("sale", dataReq);
        let data = {
          labels: [],
          datasets: [],
        };

        let totalsale = [];
        res.data.map((x, i) => {
          if (data.labels.length === 0) {
            if (this.selects.period === "today") {
              data.labels = x.details.map((d, i) => i);
            } else if (this.selects.period === "last7days") {
              data.labels = x.details.map((d, i) => this.getDate(d.period));
            } else {
              data.labels = x.details.map((d, i) => MONTHS[i]);
            }
          }
          let color = i >= COLORS.length ? this.getRandomColor() : COLORS[i];
          if (i === 0) {
            x.details.map((d) => {
              totalsale.push(d.totalSale);
            });
          } else {
            x.details.map((d, index) => {
              d.totalSale = d.totalSale + totalsale[index];
            });
          }

          data.datasets.push({
            label: x.package,
            borderColor: color,
            backgroundColor: this.transparentize(color),
            data: x.details.map((d) => d.totalSale),
            fill: true,
          });
        });
        if (data.labels.length > 0) {
          this.hasSaleData = true;
        } else {
          this.hasSaleData = false;
        }

        this.$refs.chartRef.options.plugins.title = {
          text: "Sales Dashboard",
          display: true,
        };

        this.$refs.chartRef.options.scales.x = {
          title: {
            display: true,
            text:
              dataReq.period === "today"
                ? "Hours"
                : dataReq.period === "last7days"
                ? "Days"
                : "Month",
          },
          display: true,
        };
        this.$refs.chartRef.options.scales.y = {
          title: {
            display: true,
            text: "Total Sales (THB)",
          },
          display: true,
        };

        this.$refs.chartRef.options.interaction = {
          intersect: false,
          mode: "index",
        };

        this.$refs.chartRef.data.datasets = data.datasets;
        this.$refs.chartRef.data.labels = data.labels;
        this.$refs.chartRef.update(250);
      } catch (error) {
        console.log(error);
      } finally {
        this.dataReceiving = false;
      }
    },
    async getNoOfSale(dataReq) {
      try {
        let res = await dashboardservice.get("noofsale", dataReq);
        let data = {
          labels: [],
          datasets: [],
        };

        if (data.labels.length === 0) {
          if (this.selects.period === "today") {
            data.labels = res.data.map((d, i) => i);
          } else if (this.selects.period === "last7days") {
            data.labels = res.data.map((d, i) => this.getDate(d.period));
          } else {
            data.labels = res.data.map((d, i) => MONTHS[i]);
          }
        }

        data.datasets.push({
          label: "No of Sales",
          borderColor: COLORS[0],
          backgroundColor: this.transparentize(COLORS[0]),
          data: res.data.map((d) => d.totalSale),
        });

        if (data.labels.length > 0) {
          this.hasNoData = true;
        } else {
          this.hasNoData = false;
        }

        this.$refs.chartNoRef.options.interaction = {
          intersect: false,
          mode: "index",
        };

        this.$refs.chartNoRef.data.datasets = data.datasets;
        this.$refs.chartNoRef.data.labels = data.labels;
        this.$refs.chartNoRef.update(250);
      } catch (error) {
        console.log(error);
      }
    },
    async getSaleRevenue(dataReq) {
      try {
        let res = await dashboardservice.get("salesrevenue", dataReq);
        this.salesRevenue.period = this.selects.periods.find(
          (x) => x.value === this.selects.period
        ).label;
        this.salesRevenue.total = res.data.toLocaleString(undefined, {
          minimumFractionDigits: 2,
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getTop3(dataReq) {
      try {
        let res = await dashboardservice.get("top3", dataReq);
        this.tableData = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getDailyRevenue(dataReq) {
      try {
        let res = await dashboardservice.get("dailyrevenue", dataReq);
        let data = {
          labels: [],
          datasets: [],
        };
        data.labels = res.data.map((d, i) => d.gameName);
        data.datasets.push({
          label: "Revenue",
          borderColor: COLORS[0],
          backgroundColor: this.transparentize(COLORS[0]),
          data: res.data.map((d) => d.totalSale),
        });
        this.$refs.chartDailyRef.options.interaction = {
          intersect: false,
          mode: "index",
        };
        this.$refs.chartDailyRef.data.datasets = data.datasets;
        this.$refs.chartDailyRef.data.labels = data.labels;
        this.$refs.chartDailyRef.update(250);
      } catch (error) {
        console.log(error);
      }
    },
    async getSaleType(dataReq) {
      try {
        let res = await dashboardservice.get("saletype", dataReq);
        let data = {
          labels: [],
          datasets: [],
        };
        let total = 0;

        data.labels = res.data.map((d, i) => {
          total += d.totalSale;
          return d.packageName;
        });
        data.datasets.push({
          label: "Sales Type",
          borderColor: Object.values(COLORS),
          backgroundColor: Object.values(COLORS),
          data: res.data.map((d) => {
            return `${(d.totalSale * 100) / total}`;
          }),
        });

        if (data.labels.length > 0) {
          this.hasNoData = true;
        } else {
          this.hasNoData = false;
        }
        this.$refs.chartSaleTypeRef.options.interaction = {
          intersect: false,
          mode: "index",
        };

        this.$refs.chartSaleTypeRef.options.plugins = {
          tooltip: {
            callbacks: {
              label(tooltipItem) {
                return `${
                  tooltipItem.label
                } : ${tooltipItem.parsed.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                })} %`;
              },
            },
          },
        };

        this.$refs.chartSaleTypeRef.data.datasets = data.datasets;
        this.$refs.chartSaleTypeRef.data.labels = data.labels;
        this.$refs.chartSaleTypeRef.update(250);
      } catch (error) {
        console.log(error);
      }
    },
    beforeRenderLogic() {},
    transparentize(value, opacity) {
      var alpha = opacity === undefined ? 0.5 : 1 - opacity;
      return colorLib(value).alpha(alpha).rgbString();
    },
    getDate(value) {
      if (value) return moment(value).format("DD/MM/YYYY");
      return "";
    },
  },
  data() {
    return {
      datacollection: null,
      selects: {
        games: [],
        game: null,
        gameLoaded: false,
        period: null,
        periods: [
          {
            value: "today",
            label: "Today",
          },
          {
            value: "last7days",
            label: "Last 7 Days",
          },
          {
            value: "thisyear",
            label: "This Year",
          },
        ],
        paymentMethods: [],
        paymentMethod: null,
        paymentLoaded: false,
      },
      canAccess: null,
      dataReceiving: false,
      hasSaleData: false,
      hasNoData: false,
      salePeriodChart: {
        id: "saleperiod",
        type: "line",
        options: {
          elements: {
            line: {
              tension: 0.4,
            },
          },
          plugins: {
            filler: {
              propagate: true,
            },
          },
          interaction: {
            intersect: false,
            mode: "index",
          },
        },
        data: {},
      },
      noOfSaleChart: {
        id: "noofsale",
        type: "line",
        options: {
          elements: {
            line: {
              tension: 0.4,
            },
          },
          plugins: {
            filler: {
              propagate: true,
            },
          },
          interaction: {
            intersect: false,
            mode: "index",
          },
        },
        data: {},
      },
      dailyChart: {
        id: "bar",
        type: "bar",
        options: {
          elements: {
            line: {
              tension: 0.4,
            },
          },
          plugins: {
            filler: {
              propagate: true,
            },
          },
          interaction: {
            intersect: false,
            mode: "index",
          },
        },
        data: {},
      },
      saleTypeChart: {
        id: "pie",
        type: "pie",
        options: {
          elements: {
            line: {
              tension: 0.4,
            },
          },
          plugins: {
            filler: {
              propagate: true,
            },
          },
          interaction: {
            intersect: false,
            mode: "index",
          },
        },
        data: {},
      },
      salesRevenue: {
        period: "",
        total: "0",
      },
      tableData: [],
    };
  },
  async beforeMount() {
    this.uid = await configuration.getUid();
    let result = await configuration.getIdTokenResult();
    if (result) {
      this.role = result.claims?.role || this.role;
      if (this.role === "admin" || this.role === "manager") {
        await this.getGames();
        await this.getPaymentMethods();
        this.canAccess = true;
      } else {
        this.canAccess = false;
      }
    } else {
      this.canAccess = false;
    }
  },
};
</script>

<style>
</style>